import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'app/@core/services/base.service';
import { IUpdatedPreferenceJson } from 'app/shared/interfaces/companyData.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TIMEZONES } from './timezones';
import { UtilitiesService } from 'app/@core/services/utilities.service';

@Component({
  selector: 'shipment-status',
  templateUrl: './shipment-status.component.html',
  styleUrls: ['./shipment-status.component.scss']
})
export class ShipmentStatusComponent implements OnInit {
  @ViewChildren('stopSection') stopSections!: QueryList<ElementRef>;
  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef<HTMLDivElement>;

  // ---------------------------------------- Component Properties ------------------------------------------- 
  activeStopIndex = 0;
  isCollapsed: boolean = false;
  isDetailedView!: boolean;
  event: any;
  refrenceNumber!: string | number | null;
  shipmentRefrenceNumber: any;
  loadId!: string | number;
  companyLogoUrl: string;
  actualWidth: string;
  isScrollable: boolean;
  showLeft = false;
  showRight = false;
  statusData: any;
  currentDate: Date = new Date();
  events: any;
  companyData: IUpdatedPreferenceJson;
  errorMessage: string;
  loading: boolean;
  progressBarData: any[];
  updatedEnroute: any;
  latestEnrouteEvent: any;
  refNumbers!: any;
  currentRefIndex: number = 0;
  selectedTimezone: any = '';
  timezones: any = TIMEZONES;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private baseService: BaseService, private spinner: NgxSpinnerService, private toastr: ToastrService, private utitityService: UtilitiesService) { }

  // ---------------------------------------------Component Lifecycle Hooks ------------------------------------------------------
  ngOnInit(): void {
    const userEnteredSecondaryRefNums = localStorage.getItem('userEnteredSecondaryRefNums');
    if (userEnteredSecondaryRefNums) {
      this.refrenceNumber = JSON.parse(userEnteredSecondaryRefNums);
    }
    this.activatedRoute.paramMap.subscribe(params => {
      const shipmentRefNumber = params.get('refrenceNumber');
      if (shipmentRefNumber) {
        this.refNumbers = shipmentRefNumber.split(',');
      }
    });

    const companyPrefrences = localStorage.getItem('companyPrefrences');
    if (companyPrefrences) {
      this.companyData = JSON.parse(companyPrefrences);
    }
    this.spinner.show(undefined,
      {
        type: 'ball-scale-multiple',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      }
    );

    // Get Shipment Number From Route 
    this.activatedRoute.params.subscribe(params => {
      this.shipmentRefrenceNumber = params['refrenceNumber'] || '';
      this.loadId = this.shipmentRefrenceNumber;
    });
    this.utitityService.timeZone$.subscribe((zone: string) => {
      if (zone) {
        this.selectedTimezone = this.timezones.find((item: any) => item.display === zone);
      } else {
        this.selectedTimezone = { value: 'Multiple Time Zone', display: '', name: 'Multi Time Zone', offset: '', iana: '' };

      }
    });
  }

  // --------------------------------------------- Public Methods -----------------------------------------------------
  get currentRef(): string {
    return this.refNumbers[this.currentRefIndex];
  }

  nextRef() {
    if (this.currentRefIndex < this.refNumbers.length - 1) {
      this.currentRefIndex++;
    }
  }

  prevRef() {
    if (this.currentRefIndex > 0) {
      this.currentRefIndex--;
    }
  }
  /**
   * Store shipment ref number to session storage on change 
   */
  onReferenceNumberChange() {
    sessionStorage.setItem('shipmentRefrenceNumber', JSON.stringify(this.refrenceNumber));
  }

  navigateToLogin() {
    sessionStorage.removeItem('shipmentRefrenceNumber')
    const companyName = this.companyData.nickName;
    this.router.navigateByUrl(`/${companyName}`);
  }

  /**
   * Track Shipment By Refrence Number
  */
  trackShipment() {
    localStorage.setItem('userEnteredSecondaryRefNums', JSON.stringify(this.refrenceNumber));
    this.spinner.show(undefined,
      {
        type: 'ball-scale-multiple',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      }
    );
    const queryParams = new HttpParams()
      .set('companyId', this.companyData.companyId)
      .set('srnInput', this.refrenceNumber);
    this.baseService.getRefNumbers('Shipment/get-shipment-reference-numbers', queryParams).subscribe(
      {
        next: (response) => {
          // const refNumbers = response.map((item: any) => item.primaryReferenceNumber);
          const refNumbers = response.map((item: any) => {
            const isNotFound = item.srNs.every((sr: any) => sr.value === 'Not Found');
            if (isNotFound) {
              item.primaryReferenceNumber = item.primaryReferenceNumber + 'notfound';
            }
            return item.primaryReferenceNumber
          });
          const convertToString = refNumbers.join(',');
          localStorage.setItem('searchedShipments', JSON.stringify(response));
          this.currentRefIndex = 0;
          this.router.navigate(['/track', convertToString]);

          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        }
      }
    )
  }

  /**
 * On Selecting Timezone
*/
  onTimezoneChange(abbreviation: any) {
    const timeZone = abbreviation;
    this.utitityService.setTimeZone(timeZone);
    if (timeZone) {
      localStorage.setItem('timezone', timeZone);
    } else {
      localStorage.removeItem('timezone');
    }

  }
}


